module.exports = __webpack_public_path__ + "static/media/checkbox_unchecked_disabled.708df20f.svg";